import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class ChatHistoryDto extends BaseEntityDto {
  userMessage: string;
  assistantResponse: string;
  tokensUsed: number;
  provider: string;
  userId: string;
  context: string;
}
